const schoolInfo = {
  state: {
    schoolInfo: {
      schoolName: '陕西工商管理硕士学院'
    }
  },
  mutations: {
    getSchoolInfo: function (state, schoolInfo) {
      state.schoolInfo = schoolInfo
    }
  }
}

export default schoolInfo



// WEBPACK FOOTER //
// ./src/store/modules/schoolInfo.js